import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("bls_admin_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await http.get("/admin/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("bls_admin_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await http.post("/admin/auth/login", { email, password });
    localStorage.setItem("bls_admin_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("bls_admin_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh }}>{children}</AuthCtx.Provider>
  );
}

export const useAdminAuth = () => useContext(AuthCtx);
